import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { QuestionnaireComponent } from './questionnaire.component';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {ControlMessageModule} from '../../control-message/control-message.module';
import {ValidationService} from '../../service/validation-service';
import {SecureURLPipeModule} from '../../util/secureURL.pipe.module';
@NgModule({
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, ControlMessageModule, SecureURLPipeModule
  ],
  declarations: [QuestionnaireComponent
  ],
  providers: [ValidationService],
  exports: [QuestionnaireComponent]
})
export class QuestionnaireModule {

}
